import IProjectSimpleSet from 'CommonTypes/Projects/IProjectSimpleSet';

export default (projectsList: IProjectSimpleSet[], projectName: string) => projectsList.find(
    value => value.value === projectName,
) || null;
